var ButtonType;
(function (ButtonType) {
    ButtonType["Primary"] = "PRIMARY";
    ButtonType["Secondary"] = "SECONDARY";
    ButtonType["Submit"] = "SUBMIT";
})(ButtonType || (ButtonType = {}));
export default ButtonType;
